import { getAuthToken } from "@/lib/auth";
import { FunctionComponent, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const ProtectedRoute: FunctionComponent = () => {
  const navigate = useNavigate();
  const authToken = getAuthToken();

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    }
  }, [authToken, navigate]);

  return authToken ? <Outlet /> : null;
};

export default ProtectedRoute;
